
import React from 'react';

const InputWithErrors = ({ input, translate, placeholder, type, className, beforeInput, afterInput, initvalue, maxlength, val, meta: { asyncValidating, touched, error } }) => {
  return (
    <div className="w-100">
      <div className="input-group">
        {beforeInput}
        <input {...input} type={type} placeholder={placeholder} className={className}  defaultValue={initvalue} value={val} maxLength={maxlength}/>
        {afterInput}
      </div>
      {touched && error && <div><span className="text-danger">{translate(error)}</span></div>}
    </div>
  );
}

export default InputWithErrors;



// WEBPACK FOOTER //
// ./src/lib/forms/InputWithErrors.js